const HeaderUser = () => {
  return <div>Header Users</div>;
};

export default HeaderUser;
